// Phone filter drawer: the list pages show their filters inline from md up, and behind this
// button below that — a tall stack of selects would otherwise fill a phone screen.

import type { ReactNode } from "react";
import { SlidersHorizontal } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

export function MobileFilters({
  /** How many filters are set away from their default — shown on the button. */
  activeCount,
  children,
}: {
  activeCount: number;
  children: ReactNode;
}) {
  return (
    <Sheet>
      <SheetTrigger
        nativeButton={false}
        render={
          <Button variant="outline" className="shrink-0">
            <SlidersHorizontal /> Filters
            {activeCount > 0 && (
              <span className="ml-1 rounded-full bg-primary px-1.5 text-[11px] leading-5 text-primary-foreground">
                {activeCount}
              </span>
            )}
          </Button>
        }
      />
      <SheetContent side="bottom" className="flex max-h-[85svh] flex-col overflow-hidden pb-safe">
        <SheetHeader className="shrink-0 border-b border-border pr-10">
          <SheetTitle>Filters</SheetTitle>
        </SheetHeader>
        <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-4">{children}</div>
        <div className="shrink-0 border-t border-border p-4">
          <SheetClose nativeButton={false} render={<Button className="w-full">Show results</Button>} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
